import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["preserveAspectRatio", "viewBox"];
import React from 'react';

var Phone = function Phone(_ref) {
  var _ref$preserveAspectRa = _ref.preserveAspectRatio,
      preserveAspectRatio = _ref$preserveAspectRa === void 0 ? 'xMidYMid meet' : _ref$preserveAspectRa,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox,
      unhandledProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({}, unhandledProps, {
    preserveAspectRatio: preserveAspectRatio,
    viewBox: viewBox
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.42383 17.1748C10.5928 20.3545 14.4492 22.8037 17.5967 22.8037C19.0039 22.8037 20.2393 22.3096 21.2275 21.2139C21.8076 20.5693 22.1621 19.8281 22.1621 19.0869C22.1621 18.5176 21.9365 17.959 21.3887 17.5723L18.0908 15.2305C17.5645 14.8652 17.1348 14.6934 16.748 14.6934C16.2432 14.6934 15.792 14.9727 15.2979 15.4668L14.5244 16.2402C14.3955 16.3584 14.2451 16.4121 14.1055 16.4121C13.9336 16.4121 13.7725 16.3477 13.665 16.2832C12.9883 15.918 11.8281 14.9297 10.7539 13.8555C9.67969 12.7812 8.68066 11.6318 8.32617 10.9443C8.26172 10.8262 8.20801 10.6758 8.20801 10.5039C8.20801 10.375 8.25098 10.2246 8.36914 10.0957L9.14258 9.31152C9.62598 8.80664 9.91602 8.36621 9.91602 7.86133C9.91602 7.46387 9.74414 7.03418 9.37891 6.51855L7.04785 3.25293C6.65039 2.69434 6.0918 2.45801 5.47949 2.45801C4.74902 2.45801 4.01855 2.78027 3.38477 3.39258C2.31055 4.40234 1.83789 5.65918 1.83789 7.04492C1.83789 10.1924 4.25488 14.0059 7.42383 17.1748Z"
  })));
};

Phone.displayName = 'Phone';
export default Phone;